import * as React from 'react';

var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgDecentraland = function SvgDecentraland(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 10,
        cy: 10,
        r: 10,
        fill: "url(#paint0_linear_1983_120)"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1983_120)",
        d: "M7.085 6.5V14h6.25z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M.835 14h6.25V6.5z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FC9965",
        d: "M2 16c.57.755 1.245 1.43 2 2h12c.755-.57 1.43-1.245 2-2z"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FF2D55",
        d: "M4 18c1.67 1.255 3.75 2 6 2s4.33-.745 6-2z"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint2_linear_1983_120)",
        d: "M13.415 10.5V16H18z"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FFBC5B",
        d: "M13.415 14H.835c.31.715.705 1.385 1.165 2h11.42v-2z"
    })), _path7 || (_path7 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M8.835 16h4.58v-5.5z"
    })), _circle2 || (_circle2 = /*#__PURE__*/ React.createElement("circle", {
        cx: 13.415,
        cy: 6.5,
        r: 2.5,
        fill: "#FFC95B"
    })), _circle3 || (_circle3 = /*#__PURE__*/ React.createElement("circle", {
        cx: 7.085,
        cy: 3.75,
        r: 1.25,
        fill: "#FFC95B"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1983_120",
        x1: 10,
        x2: -4.142,
        y1: -4.142,
        y2: 10,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FF2D55"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FFBC5B"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1983_120",
        x1: 7.083,
        x2: 7.083,
        y1: 6.5,
        y2: 14,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#A524B3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF2D55"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_1983_120",
        x1: 13.414,
        x2: 13.414,
        y1: 10.5,
        y2: 16,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#A524B3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#FF2D55"
    })))));
};

export { SvgDecentraland as ReactComponent };
//# sourceMappingURL=Decentraland.svg.es.js.map
